import React, { useState, useCallback } from 'react';
import TextBox from 'devextreme-react/text-box';
import { AntLocalization } from 'ante-react-kit';
import AntPickerPopup from '../AntPickerPopup';
import SearchView from './SearchView';
import useServePlaceSearch from './useServePlaceSearch';

export default function ServePlacePicker({ dataField, value, formData, session, options, onValueChanged, disabled, autoOpen, onClosed, headless }) {
    const [open, setOpen] = useState(!!autoOpen);

    const storeCode = formData ? formData.store_code : null;

    const search = useServePlaceSearch({
        enabled: open,
        storeCode
    });

    const handleOpen = useCallback(() => {
        if (disabled) return;
        if (!storeCode) return; // Theo logic editor cũ: phải chọn cửa hàng trước
        setOpen(true);
    }, [disabled, storeCode]);

    const handleClose = useCallback(() => {
        setOpen(false);
        search.reset();
        if (onClosed) onClosed();
    }, [search, onClosed]);

    const handleConfirm = useCallback((row) => {
        if (!row) return;
        const patch = {
            serve_place_code: row.serve_place_code,
            serve_place_name: row.serve_place_name
        };
        if (row.serve_place_id != null) patch.serve_place_id = row.serve_place_id;
        onValueChanged(patch);
        handleClose();
    }, [onValueChanged, handleClose]);

    const displayName = (formData && formData.serve_place_name) || value || '';

    const triggerDisabled = disabled || !storeCode;
    return (
        <>
            {!headless && (
                <div className={'spk-trigger' + (triggerDisabled ? ' spk-trigger--disabled' : '') + (displayName ? ' spk-trigger--filled' : '')}>
                    <TextBox
                        value={displayName}
                        readOnly={true}
                        disabled={triggerDisabled}
                        stylingMode="outlined"
                        showClearButton={false}
                        placeholder={AntLocalization.translateText(
                            !storeCode
                                ? { vi: 'Chọn cửa hàng trước...', en: 'Select store first...' }
                                : { vi: 'Chọn bàn/phòng...', en: 'Select place...' }
                        )}
                        onFocusIn={handleOpen}
                    />
                </div>
            )}
            <AntPickerPopup
                visible={open}
                onClose={handleClose}
                title={AntLocalization.translateText({ vi: 'Chọn bàn / phòng', en: 'Select Place' })}
                subtitle={formData && formData.store_name ? formData.store_name : null}
            >
                <SearchView
                    query={search.query}
                    onQueryChange={search.setQuery}
                    rows={search.rows}
                    totalCount={search.totalCount}
                    allCount={search.allCount}
                    loading={search.loading}
                    activeFilters={search.activeFilters}
                    onToggleFilter={search.toggleFilter}
                    filterSources={search.filterSources}
                    onPickCard={handleConfirm}
                    previewRow={null}
                />
            </AntPickerPopup>
        </>
    );
}
